import MsgCollector from './src/main';

/* istanbul ignore next */
MsgCollector.install = function(Vue) {
  Vue.component(MsgCollector.name, MsgCollector);
};

export default MsgCollector;
